import { DrawingActions, IToolbarDrawingAction, IToolbarDrawingActionItem } from './interfaces'

export const drawingActions: Record<DrawingActions, IToolbarDrawingAction> = {
  [DrawingActions.DeleteDrawings]: {
    id: DrawingActions.DeleteDrawings,
    title: 'Remove all drawings',
    icon: 'drawingActionDelete',
  },
  [DrawingActions.DeleteAutoSavedDrawings]: {
    id: DrawingActions.DeleteAutoSavedDrawings,
    title: 'Remove all autosaved drawings',
    icon: 'drawingActionDelete',
  },
}

export const getToolbarDrawingActions = ({
  isAutoSaveActive,
}: {
  isAutoSaveActive: boolean
}): Array<IToolbarDrawingActionItem> => [
  {
    defaultItem:
      drawingActions[isAutoSaveActive ? DrawingActions.DeleteAutoSavedDrawings : DrawingActions.DeleteDrawings],
  },
]
